export const trimString = (string, maxLength) => {
  if (string.length <= maxLength) return string

  const trimmedString = string.slice(0, maxLength)
  const lastSpaceIndex = trimmedString.lastIndexOf(' ')

  return lastSpaceIndex !== -1
    ? trimmedString.slice(0, lastSpaceIndex) + '...'
    : trimmedString + '...'
}
